'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AML_STATUS_LOADED = 'aml-status:loaded';
var AML_STATUS_UPDATED = 'aml-status:updated';
var AML_STATUS_QUERY = 'aml-status:query';
var UPDATE_AML_STATUS = 'aml-status:update';
var GRACE_PERIOD_QUERY = 'grace-period:query';
var GRACE_PERIOD_UPDATED = 'grace-period:updated';
var COREX_AML_STATUS_QUERY = 'corex-aml-status:query';
var COREX_GRACE_PERIOD_QUERY = 'corex-grace-period:query';
var AML_ID_AND_ADDRESS_VERIFIED = 'aml-id-and-address-verified:query';
var USER_PENDING_QUESTIONNAIRES_QUERY = 'user-pending-questionnaires:query';
var COREX_AML_FILES_QUERY = 'corex-aml-files:query';

exports.AML_ID_AND_ADDRESS_VERIFIED = AML_ID_AND_ADDRESS_VERIFIED;
exports.AML_STATUS_LOADED = AML_STATUS_LOADED;
exports.AML_STATUS_QUERY = AML_STATUS_QUERY;
exports.AML_STATUS_UPDATED = AML_STATUS_UPDATED;
exports.COREX_AML_FILES_QUERY = COREX_AML_FILES_QUERY;
exports.COREX_AML_STATUS_QUERY = COREX_AML_STATUS_QUERY;
exports.COREX_GRACE_PERIOD_QUERY = COREX_GRACE_PERIOD_QUERY;
exports.GRACE_PERIOD_QUERY = GRACE_PERIOD_QUERY;
exports.GRACE_PERIOD_UPDATED = GRACE_PERIOD_UPDATED;
exports.UPDATE_AML_STATUS = UPDATE_AML_STATUS;
exports.USER_PENDING_QUESTIONNAIRES_QUERY = USER_PENDING_QUESTIONNAIRES_QUERY;
